<template>
  <div class="view" id="spot">
    <div class='content' id="choose" v-if="browsing === false">
      <!--<div v-on:click="close" class='close-but'>&#x2715;</div>-->
      <div class='inside-closer' v-on:click="close">✖</div>
      <div class='sub-heading padding-20'>Fotoplats</div>
      <div class='heading'><div class='blue-circle'></div> {{atSpot[0]}}</div>
      <div class='spot-winner padding-20 eye' v-if="atSpotWinner !== null" v-bind:style="{ backgroundImage: 'url(' + atSpotWinner.thumburl + ')' }" v-on:click="$store.dispatch('viewSinglePhoto', atSpotWinner)"></div>
      <div class='spot-winner padding-20' v-else><br><br><br>Inget foto visas än, bli först!</div>
      <div class='sub-heading-list'  v-if="atSpotWinner">
        <div class='sub-heading'>Fotograf</div>
        <div class='text'>{{atSpotWinner.username}}</div>
        <div class='border'></div>
      </div>
      <div class='buttons'>
        <a class="upload-button blue-butt" v-on:click="challangePhoto" v-if='userHasPhotoAtSpot === false'>Ladda upp ditt bidrag</a>
        <a class="upload-button blue-butt" v-on:click="challangePhoto" v-else>Byt ut ditt foto</a>
        <a class="black-on-white-butt browse" v-on:click="browsePhotos">Se foton från platsen</a>
      </div>
      <div class='padding-80'></div>
    </div>
    <div class="content" id="browse" v-else>
      <div class='inside-closer' v-on:click="close">✖</div>
      <div class='sub-heading padding-20'>Fotoplats</div>
      <div class='heading'><div class='blue-circle'></div> {{atSpot[0]}}</div>
      <div class='sub-heading padding-40 pad-sides'>
        Foton på platsen
      </div>
      <div v-if="atSpotPhotosLoaded === true" style='padding: 15px 0px;'>
        <photoFeed v-bind:photos="atSpotPhotos" show-user="true" show-spot="false">
          <div slot="empty">No photos at spot.</div>
        </photoFeed>
      </div>
      <div v-else><loader colorClass='black'></loader></div>
      <div class='padding-80'></div>
      <div class='padding-80'></div>
    </div>
  </div>
</template>

<script>
import loader from '@/components/Loader'
import photoFeed from '@/components/photoFeed'

export default {
  name: 'spot',
  data () {
    return {
      browsing: false
    }
  },
  computed: {
    atSpot () {
      return this.$store.state.atSpot
    },
    atSpotPhotos () {
      return this.$store.state.atSpotPhotos
    },
    atSpotPhotosLoaded () {
      return this.$store.state.atSpotPhotosLoaded
    },
    user () {
      return this.$store.state.user
    },
    atSpotWinner () {
      return this.$store.state.atSpotWinner
    },
    userHasPhotoAtSpot () {
      return this.$store.getters.userHasPhotoAtSpot
    },
    userVisitedSpots () {
      return this.$store.state.userVisitedSpots
    }
  },
  methods: {
    close () {
      if (this.browsing === true) {
        this.browsing = false
      } else {
        this.$store.dispatch('setAtSpot', {spotname: null, distance: 0})
      }
    },
    challangePhoto () {
      this.$store.commit('showingPhotoUpload', true)
    },
    browsePhotos () {
      this.browsing = true
    }
  },
  mounted () {
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Spot')
    }
    //  console.log(this.atSpotWinner)
    if (this.user !== null) {
      this.$store.dispatch('addUserVisitedSpot', {
        areaKey: this.$store.state.currentArea,
        spot: this.$store.state.atSpot[0]
      })
    }
  },
  beforeDestroy () {
    this.$store.dispatch('setAtSpot', {spotname: null, distance: 0})
    this.$store.commit('setAtSpotPhotosLoaded', false)
  },
  components: { loader, photoFeed }
}
</script>

<style>
#spot {
  position: relative;
  min-height:100vh;
  top: 0px;
  left: 0px;
	background-color: #fff;
	z-index: 9999;
}
.buttons {
  padding: 15px;
  padding-top: 0px;
  width: 100%;
  box-sizing: border-box;
}
.upload-button, .browse {
  margin-top: 15px;
}
.spot-winner {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-color: #131313;
  background-color: #f4f4f4;
  border-top: 0px solid #fff;
  border-bottom: 0px solid #fff;
  height: 170px;
  width: 100%;
  margin: 15px 0px;
  margin-bottom: 10px;
}
.eye {
  position: relative;
}
.eye:before {
  content: "";
  width: 25px;
  height: 15px;
  background-image: url('./../assets/eye.svg');
  display: block;
  position: absolute;
  top: 10px;
  right: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// spot.vue?3dce9426